import { Card, Heading3, Paragraph } from '@treams/treams-ui';

export function CycleMomentOptionCard(props: {
	title: string;
	description?: string;
	onClick: () => void;
}) {
	return (
		<Card onClick={props.onClick} chevron>
			<Heading3>{props.title}</Heading3>
			{props.description && <Paragraph small>{props.description}</Paragraph>}
		</Card>
	);
}
